import React from 'react';

const LinkIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g>
        <path
          d="M17.0156 6.98438C18.3906 6.98438 19.5625 7.48438 20.5312 8.48438C21.5 9.45312 21.9844 10.625 21.9844 12C21.9844 13.375 21.5 14.5625 20.5312 15.5625C19.5625 16.5312 18.3906 17.0156 17.0156 17.0156H12.9844V15.0938H17.0156C17.8594 15.0938 18.5781 14.7969 19.1719 14.2031C19.7969 13.5781 20.1094 12.8438 20.1094 12C20.1094 11.1562 19.7969 10.4375 19.1719 9.84375C18.5781 9.21875 17.8594 8.90625 17.0156 8.90625H12.9844V6.98438H17.0156ZM8.01562 12.9844V11.0156H15.9844V12.9844H8.01562ZM4.78125 9.84375C4.1875 10.4375 3.89062 11.1562 3.89062 12C3.89062 12.8438 4.1875 13.5781 4.78125 14.2031C5.40625 14.7969 6.14062 15.0938 6.98438 15.0938H11.0156V17.0156H6.98438C5.60938 17.0156 4.4375 16.5312 3.46875 15.5625C2.5 14.5625 2.01562 13.375 2.01562 12C2.01562 10.625 2.5 9.45312 3.46875 8.48438C4.4375 7.48438 5.60938 6.98438 6.98438 6.98438H11.0156V8.90625H6.98438C6.14062 8.90625 5.40625 9.21875 4.78125 9.84375Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default LinkIcon;
